import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none" ref={ref} {...props}>
    <g stroke="#383838" strokeLinecap="round" strokeLinejoin="round">
      <path
        fill="#fff"
        d="M.988 7.873c0-4.225 1.773-6.035 2.363-6.639h9.453c.59.604 2.363 2.414 2.363 6.64 0 4.827-4.655 6.608-7.018 7.212C5.786 14.482.989 12.7.989 7.872Z"
      />
      <path d="M5.22 8.302 7.3 10.445c.977-2.809 1.792-4.042 3.636-5.715" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconShield = memo(ForwardRef);
export default IconShield;
